module.exports = __webpack_public_path__ + "static/img/qh1-4.2456f38.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/qh1-4.png
// module id = 706
// module chunks = 0